import {memo} from 'react'
import {css} from '@emotion/react'
import {useMapContext} from '@/components/MindMap/index.mjs'
import NodeComment from './NodeComment.jsx'
import NodeDiff from './NodeDiff.jsx'
import NodePreview from './NodePreview.jsx'

const cssNodeContent = css({
    position: 'relative',
})

const cssNodeComment = css({
    position: 'absolute',
    bottom: '100%',
    left: '100%',
    zIndex: 1,
})

const cssNodeMode = css({
    position: 'absolute',
    top: '100%',
    left: '100%',
    zIndex: 1,
})

const NodeContent = ({node, ...props}) => {
    const map = useMapContext()

    return (
        <div
            css={cssNodeContent}
            {...props}
        >
            <map.components.NodeOuterBox node={node} />

            <NodeComment
                css={cssNodeComment}
                node={node}
            />

            <NodeDiff
                css={cssNodeMode}
                node={node}
            />

            <NodePreview
                css={cssNodeMode}
                node={node}
            />
        </div>
    )
}

const MemorizedNodeContent = memo(NodeContent, () => true)
MemorizedNodeContent.displayName = 'NodeContent'

export default MemorizedNodeContent
